import { Point } from "../../../Utils/Point";
import { AbstractBgTileModel } from "./AbstractBgTileModel";

export class BgFenceTileModel extends AbstractBgTileModel {
    readonly width = 3694;
    pos = new Point(0, -280);
}